import { motion } from "framer-motion";
import { createStyledElement } from "../../../../utils/createStyledElement";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

export const AdvantagesSectionContent = createStyledElement(motion.section, () => ({
  padding: isMobileViewport() ? "30px 16px" : "50px 40px",
  overflow: "hidden",
}));

export const AdvantagesSectionContainer = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  marginTop: 50,
  gap: isMobileViewport() ? 28 : 100,
  flexDirection: isMobileViewport() ? "column" : "row",
  width: "100%",
}));

export const Pane = createStyledElement("div", () => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: isMobileViewport() ? 28 : 50,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
}));
